import { Autocomplete } from 'stimulus-autocomplete'
import { startStimulus } from './application'
import AvatarPickerController from './avatar_picker_controller'
import BadgesController from './badges_controller'
import LibraryController from './library_controller'
import MobileNavController from './mobile_nav_controller'
import ReadingEntriesController from './reading_entries_controller'
import ReadingTrackerController from './reading_tracker_controller'
import ReadingTrackerLinkController from './reading_tracker_link_controller'

const application = startStimulus()

application.register('avatar-picker', AvatarPickerController)
application.register('badges', BadgesController)
application.register('library', LibraryController)
application.register('mobile-nav', MobileNavController)
application.register('reading-entries', ReadingEntriesController)
application.register('reading-tracker', ReadingTrackerController)
application.register('reading-tracker-link', ReadingTrackerLinkController)
application.register('autocomplete', Autocomplete)

export { application }
